export const SET_SELECTED_REQUEST_ID = 'SET_SELECTED_REQUEST_ID';
export const SET_REQUEST_DRAWER_VISIBLE = 'SET_REQUEST_DRAWER_VISIBLE';

export const setSelectedRequestId = (payload) => ({
  type: SET_SELECTED_REQUEST_ID,
  payload,
});

export const setRequestDrawerVisible = (payload) => ({
  type: SET_REQUEST_DRAWER_VISIBLE,
  payload,
});